// removed by extract-text-webpack-plugin
module.exports = {"block":"BrandColorValue_block_2sF7t","title":"BrandColorValue_title_1G6Ga","auxColorTitle":"BrandColorValue_auxColorTitle_1IVu4","value":"BrandColorValue_value_2UZPf"};